import { memo } from "react";

import { SortStateDescriptor } from "components/Filters/types";
import { Module } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useModulesTableStore from "./useModulesTableStore";
import { MODULES_TABLE_CELLS } from "./Cells";
import useModulesAnalytics from "../useModulesAnalytics";
import { ANALYTICS, FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { MODULES_SORT_CONFIG } from "./constants";

type ModulesTableProps = {
  modules: Array<Module>;
  loading?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const ModulesTable = ({ modules, loading, rowsPerPage, sortCallback }: ModulesTableProps) => {
  const trackAnalytics = useModulesAnalytics();

  return (
    <TableSimple
      data={modules}
      loading={loading}
      store={useModulesTableStore}
      ariaLabel="Modules table"
      rowsPerPage={rowsPerPage}
      sortCallback={sortCallback}
      cellPerColumn={MODULES_TABLE_CELLS}
      analyticsPage={ANALYTICS.analyticsPage}
      trackAnalytics={trackAnalytics}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={MODULES_SORT_CONFIG}
      hasPagination
    />
  );
};

export default memo(ModulesTable);
